module.exports = __webpack_public_path__ + "img/constuction-icon.0ad23a63.svg";